export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const ISO_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const PAYMENT_STATUS = {
  ALL: null,
  PAID: 1,
  UNDERPAID: 2,
  UNPAID: 0,
  OVERPAID: 3,
} as const;

export type PaymentStatusFilter =
  (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const PAYMENT_STATUS_OPTIONS = [
  { value: PAYMENT_STATUS.ALL, translationKey: "common.all", field: "all" },
  { value: PAYMENT_STATUS.UNPAID, translationKey: "common.unpaid", field: "unpaid" },
  { value: PAYMENT_STATUS.PAID, translationKey: "common.paymentFull", field: "paid" },
  {
    value: PAYMENT_STATUS.UNDERPAID,
    translationKey: "common.paymentShort",
    field: "underpaid",
  },
  {
    value: PAYMENT_STATUS.OVERPAID,
    translationKey: "common.paymentExcess",
    field: "overpaid",
  },
] as const;

export const QR_TIME_PRESETS = [
  { value: "TODAY", translationKey: "common.todayShort", days: 0 },
  { value: "7DAYS", translationKey: "common.days7", days: 7 },
  { value: "30DAYS", translationKey: "common.days30", days: 30 },
  { value: "90DAYS", translationKey: "common.days90", days: 90 },
  { value: "1YEAR", translationKey: "common.year1", days: 365 },
  { value: "CUSTOM", translationKey: "common.customOption", days: null },
] as const;

export type QrTimePreset = (typeof QR_TIME_PRESETS)[number]["value"];

export const DATA_SOURCE_OPTIONS = [
  { value: "invoice", translationKey: "common.invoiceHeader" },
  // Nguồn fuel_log thuộc nghiệp vụ xăng dầu nên dùng thuật ngữ hiển thị "Xăng dầu".
  { value: "fuel_log", translationKey: "common.petroleum" },
] as const;

export type DataSourceValue = (typeof DATA_SOURCE_OPTIONS)[number]["value"];

export const DEFAULT_DATA_SOURCE_VALUES: DataSourceValue[] =
  DATA_SOURCE_OPTIONS.map((item) => item.value);

export interface PaymentSummaryCounts {
  all: number;
  paid: number;
  underpaid: number;
  unpaid: number;
  overpaid: number;
}

export const EMPTY_PAYMENT_SUMMARY: PaymentSummaryCounts = {
  all: 0,
  paid: 0,
  underpaid: 0,
  unpaid: 0,
  overpaid: 0,
};
